// 追踪链路查询字符串
export const TRACKER_LOGIN_QUERY_STR = "productBusinessSource=store";

// 子菜单列表
export const SUB_MENU_LIST = [
  {
    key: "destyomni",
    text: "Mekari Desty",
    icon: "desty-omni-logo-v3",
  },
  {
    key: "destystore",
    text: "Store",
    icon: "desty-store-logo",
  },
  {
    key: "destychat",
    text: "Chat",
    icon: "desty-chat-logo-v2",
  },
  {
    key: "destypos",
    text: "POS",
    icon: "desty-pos-logo",
  },
  {
    key: "destypage",
    text: "Page",
    icon: "desty-page-logo",
  },
  // {
  //   key: "destywholesale",
  //   text: "Wholesale",
  //   icon: "destywholesale-logo",
  // },
];

export const SERVICE_LIST = [
  {
    key: "solutionfulfill",
    text: "Desty Fulfillment",
  },
];
